/**
 * Same switch + bar as on order list; uses OrderPages.css (imported by parent pages).
 */
function AutoRefreshBar({
  autoRefresh,
  onAutoRefreshChange,
  fetchIntervalMs,
  onRefreshNow,
  refreshNowDisabled = false,
  subtitleWhenOn,
  subtitleWhenOff,
}) {
  const onText =
    subtitleWhenOn ??
    `Odświeżanie co ${Math.round(fetchIntervalMs / 1000)} s`;
  const offText =
    subtitleWhenOff ?? "Odświeżanie co interwał jest wyłączone";

  return (
    <div className="order-refresh-bar">
      <label className="order-refresh-switch">
        <input
          type="checkbox"
          className="order-refresh-switch-input"
          checked={autoRefresh}
          onChange={(event) => onAutoRefreshChange(event.target.checked)}
        />
        <span className="order-refresh-switch-track" aria-hidden="true">
          <span className="order-refresh-switch-thumb" />
        </span>
        <span className="order-refresh-switch-copy">
          <span className="order-refresh-switch-title">Automatyczne odświeżanie</span>
          <span className="order-refresh-switch-sub">
            {autoRefresh ? onText : offText}
          </span>
        </span>
      </label>
      {!autoRefresh && (
        <button
          type="button"
          className="order-refresh-now-btn"
          onClick={onRefreshNow}
          disabled={refreshNowDisabled}
        >
          Odśwież teraz
        </button>
      )}
    </div>
  );
}

export default AutoRefreshBar;
